import React from "react";
export default function Add({ style }) {
    return (React.createElement("svg", { style: style, viewBox: "0 0 500 500" },
        React.createElement("path", { d: "M 500 250 C 500 277.614 477.614 300 450 300 L 50 300 C 22.386 300 0 277.614 0 250 C 0 222.386 22.386 200 50 200 L 450 200 C 477.614 200 500 222.386 500 250 Z M 250 0 C 277.614 0 300 22.386 300 50 L 300 450 C 300 477.614 277.614 500 250 500 C 222.386 500 200 477.614 200 450 L 200 50 C 200 22.386 222.386 0 250 0 Z" })));
}
